import Img1 from "../../../../../images/other/treatment_step1_1.jpg";
import Img2 from "../../../../../images/other/treatment_step1_2.jpg";
import Img3 from "../../../../../images/other/treatment_step1_3.jpg";
import Img4 from "../../../../../images/other/treatment_step1_4.jpg";

import { Button } from "primereact/button";

export default function ModuleTreatmentStep1(props) {
  const { onTabChange } = props;

  return (
    <>
      <div className="text-xl line-height-4 bg-yellow-100 border-1 border-400 border-round-md px-3 py-2 mb-4">
        當您的小孩被診斷為近視時，您的小孩應該接受治療嗎?本工具將幫助您了解此狀況與醫療上的治療選擇有哪些，藉以幫助您決定接受何種治療。
      </div>

      <div className="text-2xl font-bold mb-2">適用對象 / 適用狀況</div>
      <div className="text-xl">確診為近視，孩童年齡介於6至12歲國小之家長。</div>

      <div className="text-4xl text-main font-bold text-center text-shadow-1 mt-6">
        當小孩被診斷為近視時，我應該讓小孩接受治療嗎?
      </div>
      <div className="flex flex-column md:flex-row mt-3">
        <div className="w-12 md:w-6 border-1 border-400 border-round-md p-3">
          <div className="text-2xl font-bold">您要先知道，近視是甚麼?</div>
          <ol className="text-lg line-height-3 pl-4 mb-0">
            <li className="mb-2">
              近視，是一種常見眼睛屈光異常，當眼睛處於靜止狀態時，平行光線被聚焦在視網膜前方，導致遠處的物體看起來模糊。
            </li>
            <li className="mb-2">
              依據International Myopia Institute
              (IMI)(國際近視學會)的定義與分類報告-經散瞳驗光後，屈光度數等於或超過負50度(diopter
              -0.5D)定義為近視。
            </li>
            <li className="mb-2">
              近視⼀旦形成「很難」逆轉（臨床上仍有逆轉的可能），如果沒有治療，每年度數增加的速度約為75到100度左右。發病越早，晚年發⽣⾼度近視
              (500度以上)的可能性就越⼤。
            </li>
            <li>
              高度近視合併症有黃斑部病變、視網膜剝離、白內障，導致視⼒不佳甚⾄失明。
            </li>
          </ol>
        </div>
        <div className="w-12 md:w-6 border-1 border-400 border-round-md p-3 mt-2 md:mt-0 md:ml-2">
          <div className="text-2xl font-bold">
            目前研究證實有效的治療選項有哪些?
          </div>
          <ol className="text-lg line-height-3 pl-4 mb-0">
            <li className="mb-2">
              戶外活動–每天到戶外活動總時間超過
              <span className="font-bold underline">120分鐘</span>
              ，讓孩子中斷近距離用眼，並增加接觸自然光線的機會；每週戶外活動達11小時，1年平均可減少55%的近視發生機會。
            </li>
            <li className="mb-2">
              阿托品眼藥水-有不同的濃度分別為0.01%、0.05%、0.125%，依醫師指示每晚點，可延緩30%~70%近視加深的速度(濃度越高效果越好)。
            </li>
            <li>
              光學矯正-改變鏡片的周邊光學設計，如角膜塑型片(夜間配戴)
              和學童近視控制專用日拋(日間配戴)皆可減緩近視進展50~60%；近視控制框架鏡片則可減緩近視進展30~60%(依產品不同)。
            </li>
          </ol>
        </div>
      </div>

      <div
        className="text-4xl text-main font-bold text-center text-shadow-2 mt-6"
        content="目前實驗研究證實有效控制近視的治療"
      >
        目前實驗研究證實有效控制近視的治療
      </div>
      <div className="flex flex-column md:flex-row mt-3">
        <div className="w-12 md:w-4 border-1 border-400 border-round-md p-3">
          <div className="flex flex-row md:flex-column">
            <div className="mr-3 md:mr-0">
              <div className="text-2xl font-bold text-center mb-3">
                戶外活動
              </div>
              <div className="text-lg line-height-3">
                長時間戶外活動增加接觸自然光線，增加多巴胺，
                改善脈絡膜血流，穩定鞏膜，避免眼軸快速生長，有助於預防或延緩近視。
              </div>
            </div>
            <div className="text-center md:mt-3">
              <img className="w-9rem md:w-9" src={Img1} alt="戶外活動" />
            </div>
          </div>
        </div>
        <div className="w-12 md:w-4 border-1 border-400 border-round-md p-3 mt-2 md:mt-0 md:ml-2">
          <div className="flex flex-row md:flex-column">
            <div className="mr-3 md:mr-0">
              <div className="text-2xl font-bold text-center mb-3">
                阿托品眼藥
              </div>
              <div className="text-lg line-height-3">
                阿托品是一種非選擇性的膜上乙醯膽鹼受體拮抗劑，為一種處方眼藥水，用於暫時擴張（打開）瞳孔並限制眼睛調節（對焦）的能力。通過與控制眼睛生長的一些受體進行交互作用，可以減緩近視的進展。
              </div>
            </div>
            <div className="text-center mt-4">
              <img className="w-7rem md:w-5" src={Img2} alt="阿托品眼藥" />
            </div>
          </div>
        </div>
        <div className="w-12 md:w-4 border-1 border-400 border-round-md p-3 mt-2 md:mt-0 md:ml-2">
          <div className="flex flex-row md:flex-column">
            <div className="mr-3 md:mr-0">
              <div className="text-2xl font-bold text-center mb-3">
                光學矯正
              </div>
              <div className="text-lg line-height-3">
                <div className="mb-2">
                  鏡片通過將光聚焦在眼睛的周圍或視網膜前來減緩兒童的近視進展。
                </div>
                <div className="mb-2">
                  基礎選項 ‧ 一般單焦眼鏡足度矯正，但有效控制
                  <span className="underline">效果最小</span>
                </div>
                <div className="mb-1">目前光學矯正有3種進階選項</div>
                <ol className="pl-4 my-0">
                  <li className="mb-1">角膜塑型片-夜間配戴</li>
                  <li className="mb-1">近視控制專用日拋隱形眼鏡</li>
                  <li>近視控制框架鏡片</li>
                </ol>
              </div>
            </div>

            <div className="flex flex-column md:flex-row align-items-center justify-content-center md:mt-4">
              <img className="w-6rem md:w-4" src={Img3} alt="光學矯正1" />
              <img
                className="w-8rem md:w-6 mt-5 md:mt-0 md:ml-6"
                src={Img4}
                alt="光學矯正2"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mt-3">
        <div className="inline-block text-2xl text-white font-bold text-center bg-blue-400 px-2 py-1">
          研究證實 合併治療的效果比單一治療更有效控制近視的進展
        </div>
      </div>

      <div
        className="text-4xl text-main font-bold text-center text-shadow-2 mt-6"
        content="三項控制近視治療方法之副作用"
      >
        三項控制近視治療方法之副作用
      </div>
      <div className="flex flex-column md:flex-row mt-3">
        <div className="w-12 md:w-4 border-1 border-400 border-round-md p-3 md:ml-2">
          <div className="text-2xl font-bold mb-3">戶外活動</div>
          <div className="text-lg line-height-3">
            戶外活動是一個自然情境下預防與控制近視的方法，唯須注意長時間紫外線照射，防曬措施不可少，如戴帽子阻隔陽光、不要直接注視強光應配戴太陽眼鏡。
          </div>
        </div>
        <div className="w-12 md:w-4 border-1 border-400 border-round-md p-3 mt-2 md:mt-0 md:ml-2">
          <div className="text-2xl font-bold mb-3">阿托品眼藥</div>
          <div className="text-lg line-height-3">
            阿托品眼藥水最常見的副作用是暫時的刺痛(短效，長效並非皆有)或灼熱感、視力模糊以及對光的敏感性。高濃度、中等濃度與低濃度出現畏光副作用比率分別為43.1%、17.8%與6.3%，一般而言，濃度越高效果越好，但其散瞳畏光的副作用就越強，較低劑量可能會減少這些副作用。
          </div>
        </div>
        <div className="w-12 md:w-4 border-1 border-400 border-round-md p-3 mt-2 md:mt-0 md:ml-2">
          <div className="text-2xl font-bold mb-3">光學矯正</div>
          <div className="text-lg line-height-3">
            角膜塑型片是所有光學矯正中產生副作用機率較大的方式，最嚴重的合併症是微生物角膜炎，造成角膜腫脹疼痛，綠膿桿菌與阿米巴原蟲感染占比例最高，嚴重甚至需要移除受感染的角膜，將造成失明；台灣病例分析報告發現，因配戴角膜塑型片導致兒童微生物角膜炎，以目前角膜塑型佩戴技術，感染風險低於萬分之一。
          </div>
        </div>
      </div>

      <div className="text-center my-3">
        <Button
          className="p-button-warning text-white px-3 rotate-icon-xy-180 rotate-icon-y-180"
          type="button"
          label="下一步：比較"
          icon="fa fa-reply bg-main border-round-md p-1"
          onClick={() => onTabChange({ index: 1 })}
        />
      </div>
    </>
  );
}
